/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ScoreConcertDto as FeatureMusicLibraryScoreConcertDto } from '../models/feature/music-library/score-concert-dto';
import { getScoreConcerts } from '../fn/score/get-score-concerts';
import { GetScoreConcerts$Params } from '../fn/score/get-score-concerts';

@Injectable({ providedIn: 'root' })
export class ScoreClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scoreGetScoreConcerts()` */
  static readonly ScoreGetScoreConcertsPath = '/music-library/score-concerts/{scoreId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getScoreConcerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScoreConcerts$Response(scoreId: number, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureMusicLibraryScoreConcertDto>>> {
    const obs = getScoreConcerts(this.http, this.rootUrl, { scoreId } satisfies GetScoreConcerts$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getScoreConcerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScoreConcerts(scoreId: number, context?: HttpContext): Observable<Array<FeatureMusicLibraryScoreConcertDto>> {
    const resp = this.getScoreConcerts$Response(scoreId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FeatureMusicLibraryScoreConcertDto>>): Array<FeatureMusicLibraryScoreConcertDto> => r.body)
    );
  }

}
